

export const STORAGE_KEYS = Object.freeze({
  session: "business.session", adminSession: "business.admin_session",
  customerSession: "business.customer_session", vendors: "business.vendors",
  admins: "business.admins", customers: "business.customers", adminChangeRequests: "business.admin_change_requests",
  orders: "business.orders", bookings: "business.bookings",
  serviceRequests: "business.service_requests",
  supportTickets: "business.support_tickets",
  planMatrix: "business.plan_matrix",
  personaMatrix: "business.persona_matrix", chats: "business.customer_chats",
  seed: "business.seed_done",
});
export function read(key, fallback) {
  try { const raw = localStorage.getItem(key); return raw ? JSON.parse(raw) : fallback; }
  catch { return fallback; }
}
export const write = (key, value) => localStorage.setItem(key, JSON.stringify(value));
export const remove = (key) => localStorage.removeItem(key);
